import { API } from "../Client";
import { SearchResults } from "./types";

namespace SearchService {
    export async function searchAssets(query: string, includeLatestQuote = false): Promise<SearchResults> {
        const sanitized = query.toLowerCase().trim();

        const res = await API.get('/stock-assets/data/search-new', {
            params: {
                searchTerm: sanitized,
                includeLatestQuote
            },
        });
        
        return res?.data;
    }
}

export default SearchService;